import React from "react";
import UserDataService from "../services/UserDataService";
import PicCropper from "./PicCropper";
import Resizer from "react-image-file-resizer";
import firebase from "firebase";
import algoliasearch from "algoliasearch"
import Editor from "../components/Editor";
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import i18n from '../components/lang/i18n'

const debug = process.env.GATSBY_DEBUG;


export default class ProfileUser extends React.Component {
  constructor(props) {
    super(props);
    this.coverRef = React.createRef();
    this.pic1Ref = React.createRef();
    this.editorRef = React.createRef();
    this.showMessage = this.showMessage.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.onChangePrename = this.onChangePrename.bind(this);
    this.onChangeSurname = this.onChangeSurname.bind(this);
    this.onChangeMail = this.onChangeMail.bind(this);
    this.onChangeShowMail = this.onChangeShowMail.bind(this);
    this.onChangeCompany = this.onChangeCompany.bind(this);
    this.onChangeJobTitle = this.onChangeJobTitle.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.onChangeStreet = this.onChangeStreet.bind(this);
    this.onChangeNumber = this.onChangeNumber.bind(this);
    this.onChangeZipcode = this.onChangeZipcode.bind(this);
    this.onChangeCity = this.onChangeCity.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onChangeShowAddress = this.onChangeShowAddress.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangeShowPhone = this.onChangeShowPhone.bind(this);
    this.onChangeWebsite = this.onChangeWebsite.bind(this);
    this.onChangeCitation = this.onChangeCitation.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeFacebook = this.onChangeFacebook.bind(this);
    this.onChangeInstagram = this.onChangeInstagram.bind(this);
    this.onChangePinterest = this.onChangePinterest.bind(this);
    this.onChangeTwitter = this.onChangeTwitter.bind(this);
    this.onChangeXing = this.onChangeXing.bind(this);
    this.onChangeLinkedIn = this.onChangeLinkedIn.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.updateActive = this.updateActive.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.uploadChanges = this.uploadChanges.bind(this);
    // this.deleteUser = this.deleteUser.bind(this);

    this.state = {
      currentUser: {
        userId: null,
        prename: "", 
        surname: "", 
        mail: "",
        showMail: false,
        company: "",
        jobtitle: "",
        category: "", 
        street: "", 
        number: "", 
        zipcode: "", 
        city: "", 
        country: "", 
        showAddress: false,
        phone: "", 
        showPhone: false,
        website: "",
        citation: "",
        description: "",
        cover: "",
        pic1: "",
        facebook: "",
        instagram: "",
        pinterest: "",
        twitter: "",
        xing: "",
        linkedin: "",
        position: false,
        isActive: false,
      },
      message: "",
      editProfile: false,
      isUser: false,
    };
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  componentDidMount() {
    this.setState({
      currentUser: this.props.user,
    });
  }

  setStateFromChild = (childData) => {
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          description: childData,
        },
      };
    });
  }

  editProfile(state, user, authedId) {
    if(user.userId === authedId) {
      this.setState({
        editProfile: state,
        currentUser: user,
        isUser: true,
        message: "",
      });
    }
  }
  
  onChangePrename(e) {
    const prename = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          prename: prename,
        },
      };
    });
  }

  onChangeSurname(e) {
    const surname = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          surname: surname,
        },
      };
    });
  }
  onChangeMail(e) {
    const mail = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          mail: mail,
        },
      };
    });
  }
  onChangeShowMail(e) {
    const showMail = e.target.checked;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          showMail: showMail,
        },
      };
    });
  }
  onChangeCompany(e) {
    const company = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          company: company,
        },
      };
    });
  }
  onChangeJobTitle(e) {
    const jobtitle = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          jobtitle: jobtitle,
        },
      };
    });
  }
  onChangeCategory(e) {
    const category = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          category: category,
        },
      };
    });
  }
  onChangeStreet(e) {
    const street = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          street: street,
        },
      };
    });
  }
  onChangeNumber(e) {
    const number = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          number: number,
        },
      };
    });
  }
  onChangeZipcode(e) {
    const zipcode = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          zipcode: zipcode,
        },
      };
    });
  }
  onChangeCity(e) {
    const city = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          city: city,
        },
      };
    });
  }
  onChangeCountry(e) {
    const country = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          country: country,
        },
      };
    });
  }
  onChangeShowAddress(e) {
    const showAddress = e.target.checked;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          showAddress: showAddress,
        },
      };
    });
  }
  onChangePhone(e) {
    const phone = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          phone: phone,
        },
      };
    });
  }
  onChangeShowPhone(e) {
    const showPhone = e.target.checked;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          showPhone: showPhone,
        },
      };
    });
  }
  onChangeWebsite(e) {
    const website = e.target.value;
    this.setState(function (prevState) {
      return {
        currentUser: {
          ...prevState.currentUser,
          website: website,
        },
      };
    });
  }
  onChangeCitation(e) {
    const citation = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        citation: citation,
      },
    }));
  }
  onChangeDescription(e) {
    const description = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        description: description,
      },
    }));
  }
  onChangeFacebook(e) {
    const facebook = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        facebook: facebook,
      },
    }));
  }
  onChangeInstagram(e) {
    const instagram = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        instagram: instagram,
      },
    }));
  }
  onChangePinterest(e) {
    const pinterest = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        pinterest: pinterest,
      },
    }));
  }
  onChangeTwitter(e) {
    const twitter = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        twitter: twitter,
      },
    }));
  }
  onChangeXing(e) {
    const xing = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        xing: xing,
      },
    }));
  }
  onChangeLinkedIn(e) {
    const linkedin = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        linkedin: linkedin,
      },
    }));
  }

  handleChange(e) {
    const category = e.target.value;
    this.setState((prevState) => ({
      currentUser: {
        ...prevState.currentUser,
        category: category,
      },
    }));
  }

  handleBlur(e) {
    this.handleChange(e);
  }

  updateActive(status) {
    UserDataService.update(this.state.currentUser.userId, {
      isActive: status,
    })
      .then(() => {
        this.setState((prevState) => ({
          currentUser: {
            ...prevState.currentUser,
            isActive: status,
          },
          message: i18n.t("user_message_status_success", "Der Status wurde erfolgreich geändert."),
        }));
      })
      .catch((e) => {
        if (debug) console.error(e);
      });
  }

  updateUser() {
    this.showMessage(i18n.t("user_message_upload_started", "Die Änderungen werden hochgeladen ..."))
    var storage = firebase.storage();
    var storageRef = storage.ref();
    var userId = this.state.currentUser.userId;

    const data = {
      userId: this.state.currentUser.userId,
      objectID: this.state.currentUser.userId,
      prename: this.state.currentUser.prename,
      surname: this.state.currentUser.surname,
      mail: this.state.currentUser.mail,
      showMail: this.state.currentUser.showMail,
      company: this.state.currentUser.company,
      jobtitle: this.state.currentUser.jobtitle,
      category: this.state.currentUser.category,
      street: this.state.currentUser.street,
      number: this.state.currentUser.number,
      zipcode: this.state.currentUser.zipcode,
      city: this.state.currentUser.city,
      country: this.state.currentUser.country,
      showAddress: this.state.currentUser.showAddress,
      phone: this.state.currentUser.phone,
      showPhone: this.state.currentUser.showPhone,
      website: this.state.currentUser.website,
      citation: this.state.currentUser.citation,
      description: this.state.currentUser.description,
      cover: this.state.currentUser.cover,
      pic1: this.state.currentUser.pic1,
      facebook: this.state.currentUser.facebook,
      instagram: this.state.currentUser.instagram,
      pinterest: this.state.currentUser.pinterest,
      twitter: this.state.currentUser.twitter,
      xing: this.state.currentUser.xing,
      linkedin: this.state.currentUser.linkedin,
      position: this.state.currentUser.position,
      isActive: this.state.currentUser.isActive
    };

    if (this.coverRef.current.getCropped()) {
      data.cover = dataURItoFile(this.coverRef.current.getCropped(), "cover");
    }

    if (this.pic1Ref.current.getCropped()) {
      data.pic1 = dataURItoFile(this.pic1Ref.current.getCropped(), "pic1");
    }

    const promise = getCoordinates(this.state.currentUser.street + " " + this.state.currentUser.number + ", " + this.state.currentUser.zipcode + " " + this.state.currentUser.city + ", " + this.state.currentUser.country, data);
    const getPosition = () => {
        promise.then((results) => {
          if (debug) console.log(results);
          // Upload with new position
          this.uploadChanges(userId, storageRef, results)
        }).catch((e) => {
          if (debug) console.error(e);
          // Upload with old position
          this.uploadChanges(userId, storageRef, data)
        });
    }
    getPosition();
  }

  uploadChanges(userId, storageRef, data) {
    const promise = uploadImagesAndGetUris(userId, storageRef, data);
            const uploadUserToFirebase = () => {
                promise.then((ret) => {
        
                  var user = firebase.auth().currentUser;
                  //Update AUTH User
                  if (user != null) {
                      user.updateProfile({
                          displayName: ret.prename + " " + ret.surname,
                          photoURL: ret.pic1
                          }).then(function() {
                          // Update successful.
                          }).catch(function(error) {
                          // An error happened.
                            if (debug) console.error(error)
                          });
                  }
        
                  /* Push to Algolia */
                  const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_ADMIN_KEY);
                  const index = client.initIndex(process.env.GATSBY_ALGOLIA_INDICES_USERS);
                  
                  var object = ret;

                  if (object.position && object.position.length) {
                    object._geoloc = {"lat": object.position[0], "lng": object.position[1]};
                  }
                  
                  index.saveObject(object)
                    .then(({ objectID }) => {
                      if (debug) console.log("Synced with Algolia: " + objectID);
                    })
                    .catch(err => {
                      if (debug) console.error(err);
                    });
        
                  //Update Realtime DB User
                  UserDataService.update(ret.userId, ret)
                  .then(() => {
                    this.setState({
                      message: i18n.t("user_message_success", "Die Änderungen wurden gespeichert."),
                    });
                    this.props.changeEditButton(true);
                    setTimeout(
                      function() {
                          this.setState({ 
                            editProfile: false,
                            isUser: false,
                          });
                      }
                      .bind(this),
                      2000
                    );
                    })
                    .catch((e) => {
                      if (debug) console.error(e);
                    });
                });
            };
            uploadUserToFirebase();
  }

/*   deleteUser() {
    UserDataService.delete(this.state.currentUser.userId)
      .then(() => {
        alert("Benutzer gelöscht");
      })
      .catch((e) => {
        console.log(e);
      });
  } */

  render() {
    const { currentUser, isUser } = this.state;
    //const { t } = this.props
    return (
      <div>
        {currentUser && this.state.editProfile && isUser ? (
          <div>
          <h3>{i18n.t("profile_edit", "Profil bearbeiten")}</h3>
          <br/>
          <div className="edit-form">
            <form>
              <div className="field">
                <label htmlFor="prename">{i18n.t("user_prename", "Vorname")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="prename"
                  value={currentUser.prename}
                  onChange={this.onChangePrename}
                />
              </div>
              <div className="field">
                <label htmlFor="surname">{i18n.t("user_surname", "Nachname")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="surname"
                  value={currentUser.surname}
                  onChange={this.onChangeSurname}
                />
              </div>
              <div className="field">
                <label htmlFor="mail">{i18n.t("user_mail", "Mail")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="mail"
                  value={currentUser.mail}
                  readOnly
                  //onChange={this.onChangeShowMail}
                />
              </div>
              <div className="field">
                <input
                  type="checkbox"
                  id="showMail"
                  checked={currentUser.showMail}
                  onChange={this.onChangeShowMail}
                />
                <label htmlFor="showMail">{i18n.t("user_show_mail", "Mail-Adresse veröffentlichen?")}</label> 
              </div>
              <div className="field">
                <label htmlFor="company">{i18n.t("user_company", "Firma")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  value={currentUser.company}
                  onChange={this.onChangeCompany}
                />
              </div>
              <div className="field">
                <label htmlFor="jobtitle">{i18n.t("user_jobtitle", "Berufsbezeichnung")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="jobtitle"
                  value={currentUser.jobtitle}
                  onChange={this.onChangeJobTitle}
                />
              </div>
              <div className="field">
                <label htmlFor="category">{i18n.t("user_category", "Branche")}</label>
                <select
                    name="category"
                    id="category"
                    value={currentUser.category}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    style={{ display: 'block' }}
                >
                    <option value={currentUser.category}>{currentUser.category}</option>
                    <option value={i18n.t("cat_1", "AGRARWIRTSCHAFT")}>{i18n.t("cat_1", "AGRARWIRTSCHAFT")}</option>
                    <option value={i18n.t("cat_2", "BAU")}>{i18n.t("cat_2", "BAU")}</option>
                    <option value={i18n.t("cat_3", "CHEMIE & ROHSTOFFE")}>{i18n.t("cat_3", "CHEMIE & ROHSTOFFE")}</option>
                    <option value={i18n.t("cat_4", "DIENSTLEISTUNGEN & HANDWERK")}>{i18n.t("cat_4", "DIENSTLEISTUNGEN & HANDWERK")}</option>
                    <option value={i18n.t("cat_5", "E-COMMERCE")}>{i18n.t("cat_5", "E-COMMERCE")}</option>
                    <option value={i18n.t("cat_6", "ENERGIE & UMWELT")}>{i18n.t("cat_6", "ENERGIE & UMWELT")}</option>
                    <option value={i18n.t("cat_7", "ENTSPANNUNG & MEDITATION")}>{i18n.t("cat_7", "ENTSPANNUNG & MEDITATION")}</option>
                    <option value={i18n.t("cat_8", "FINANZEN, VERSICHERUNGEN & IMMOBILIEN")}>{i18n.t("cat_8", "FINANZEN, VERSICHERUNGEN & IMMOBILIEN")}</option>
                    <option value={i18n.t("cat_9", "FREIZEIT")}>{i18n.t("cat_9", "FREIZEIT")}</option>
                    <option value={i18n.t("cat_10", "GESELLSCHAFT")}>{i18n.t("cat_10", "GESELLSCHAFT")}</option>
                    <option value={i18n.t("cat_11", "HANDEL")}>{i18n.t("cat_11", "HANDEL")}</option>
                    <option value={i18n.t("cat_12", "IT")}>{i18n.t("cat_12", "IT")}</option>
                    <option value={i18n.t("cat_13", "KUNST & KULTUR")}>{i18n.t("cat_13", "KUNST & KULTUR")}</option>
                    <option value={i18n.t("cat_14", "LIFESTYLE")}>{i18n.t("cat_14", "LIFESTYLE")}</option>
                    <option value={i18n.t("cat_15", "MEDIEN")}>{i18n.t("cat_15", "MEDIEN")}</option>
                    <option value={i18n.t("cat_16", "METALL & ELEKTRONIK")}>{i18n.t("cat_16", "METALL & ELEKTRONIK")}</option>
                    <option value={i18n.t("cat_17", "PHARMA & GESUNDHEIT")}>{i18n.t("cat_17", "PHARMA & GESUNDHEIT")}</option>
                    <option value={i18n.t("cat_18", "SPORT & FITNESS")}>{i18n.t("cat_18", "SPORT & FITNESS")}</option>
                    <option value={i18n.t("cat_19", "TECHNIK & TELEKOMMUNIKATION")}>{i18n.t("cat_19", "TECHNIK & TELEKOMMUNIKATION")}</option>
                    <option value={i18n.t("cat_20", "TOURISMUS & GASTRONOMIE")}>{i18n.t("cat_20", "TOURISMUS & GASTRONOMIE")}</option>
                    <option value={i18n.t("cat_21", "VERKEHR & LOGISTIK")}>{i18n.t("cat_21", "VERKEHR & LOGISTIK")}</option>
                    <option value={i18n.t("cat_22", "WERBUNG & MARKETING")}>{i18n.t("cat_22", "WERBUNG & MARKETING")}</option>
                    <option value={i18n.t("cat_23", "WIRTSCHAFT & POLITIK")}>{i18n.t("cat_23", "WIRTSCHAFT & POLITIK")}</option>
                    <option value={i18n.t("cat_24", "SONSTIGES")}>{i18n.t("cat_24", "SONSTIGES")}</option>
                </select>
              </div>
              <div className="field">
                <label htmlFor="street">{i18n.t("user_street", "Strasse")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="street"
                  value={currentUser.street}
                  onChange={this.onChangeStreet}
                />
              </div>
              <div className="field">
                <label htmlFor="number">{i18n.t("user_number", "Hausnummer")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="number"
                  value={currentUser.number}
                  onChange={this.onChangeNumber}
                />
              </div>
              <div className="field">
                <label htmlFor="zipcode">{i18n.t("user_zipcode", "Postleitzahl")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="zipcode"
                  value={currentUser.zipcode}
                  onChange={this.onChangeZipcode}
                />
              </div>
              <div className="field">
                <label htmlFor="city">{i18n.t("user_city", "Stadt")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  value={currentUser.city}
                  onChange={this.onChangeCity}
                />
              </div>
              <div className="field">
                <label htmlFor="country">{i18n.t("user_country", "Land")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="country"
                  value={currentUser.country}
                  onChange={this.onChangeCountry}
                />
              </div>
              <div className="field">
                <input
                  type="checkbox"
                  id="showAddress"
                  checked={currentUser.showAddress}
                  onChange={this.onChangeShowAddress}
                />
                <label htmlFor="showAddress">{i18n.t("user_show_address", "Adresse veröffentlichen?")}</label>
              </div>
              <div className="field">
                <label htmlFor="phone">{i18n.t("user_phone", "Telefonnummer")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  value={currentUser.phone}
                  onChange={this.onChangePhone}
                />
              </div>
              <div className="field">
                <input
                  type="checkbox"
                  id="showPhone"
                  checked={currentUser.showPhone}
                  onChange={this.onChangeShowPhone}
                />
                <label htmlFor="showPhone">{i18n.t("user_show_phone", "Telefonnummer veröffentlichen?")}</label>
              </div>
              <div className="field">
                <label htmlFor="website">{i18n.t("user_website", "Webseite")}</label>
                <input
                  type="text"
                  className="form-control"
                  id="website"
                  value={currentUser.website}
                  onChange={this.onChangeWebsite}
                />
              </div>
              <div className="field">
                <label htmlFor="citation">{i18n.t("user_citation", "Zitat oder Kurbeschreibung")}</label>
                <textarea
                  rows="3"
                  className="form-control"
                  id="citation"
                  value={currentUser.citation}
                  onChange={this.onChangeCitation}
                />
              </div>
              <div className="field">
                <label htmlFor="description">{i18n.t("user_description", "Beschreibung")}</label>
                <Editor ref={this.editorRef} value={currentUser.description} setStateFromChild={this.setStateFromChild}/>
              </div>
              <br/>
              <h4>{i18n.t("user_pictures", "Bilder")}</h4>
              <div className="grid-wrapper">
                  <div className="col-6">
                    <label>{i18n.t("user_cover", "Cover")}</label>
                    {currentUser.cover ? (
                    <span className="image center fit"><img className="" src={currentUser.cover} alt="Coverfoto"/></span>
                    ) : (
                        <span></span>
                    )}
                  </div>
                  <div className="col-6">
                    <label>{i18n.t("user_new_cover", "Neues Cover hochladen?")}</label>
                    <PicCropper id="covercropper" type="cover" source="" ref={this.coverRef} />
                  </div>
                  <div className="col-6">
                    <label>{i18n.t("user_pic1", "Profilbild")}</label>    
                    {currentUser.pic1 ? (
                    <span className="image center fit"><img className="avatar" src={currentUser.pic1} alt="Profilbild"/></span>
                    ) : (
                        <span></span>
                    )}
                  </div>
                  <div className="col-6">
                  <label>{i18n.t("user_new_pic1", "Neues Profilbild hochladen?")}</label>
                    <PicCropper id="pic1cropper" type="pic1" source="" ref={this.pic1Ref} />
                  </div>
              </div>

              <div className="field">
                <label htmlFor="facebook">Facebook</label>
                <input
                  type="text"
                  className="form-control"
                  id="facebook"
                  value={currentUser.facebook}
                  onChange={this.onChangeFacebook}
                />
              </div>
              <div className="field">
                <label htmlFor="instagram">Instagram</label>
                <input
                  type="text"
                  className="form-control"
                  id="instagram"
                  value={currentUser.instagram}
                  onChange={this.onChangeInstagram}
                />
              </div>
              <div className="field">
                <label htmlFor="pinterest">Pinterest</label>
                <input
                  type="text"
                  className="form-control"
                  id="pinterest"
                  value={currentUser.pinterest}
                  onChange={this.onChangePinterest}
                />
              </div>
              <div className="field">
                <label htmlFor="twitter">Twitter</label>
                <input
                  type="text"
                  className="form-control"
                  id="twitter"
                  value={currentUser.twitter}
                  onChange={this.onChangeTwitter}
                />
              </div>
              <div className="field">
                <label htmlFor="xing">XING</label>
                <input
                  type="text"
                  className="form-control"
                  id="xing"
                  value={currentUser.xing}
                  onChange={this.onChangeXing}
                />
              </div>
              <div className="field">
                <label htmlFor="linkedin">LinkedIn</label>
                <input
                  type="text"
                  className="form-control"
                  id="linkedin"
                  value={currentUser.linkedin}
                  onChange={this.onChangeLinkedIn}
                />
              </div>
              <br/>
              <div className="field">
                <label>
                  <strong>{i18n.t("user_state", "Status:")}</strong>
                </label>
                {currentUser.isActive ? i18n.t("user_published", "Veröffentlicht") : i18n.t("user_not_published", "Ausstehend")}
              </div>
            </form>

{/*             <button
              className="badge badge-danger mr-2"
              onClick={this.deleteUser}
            >
              Löschen
            </button>
            &nbsp; */}
            <button
              type="submit"
              className="badge badge-success"
              onClick={this.updateUser}
            >
              {i18n.t("user_button_save", "Speichern")}
            </button>
            <br/><br/>
            <p>{this.state.message}</p>
          </div>
          </div>
        ) : (
          <span></span>
        )}
      </div>
    );
  }
}


function uploadImage(file, user, imgtype, storageRef) {
  return storageRef.child(user + '/images/' + imgtype).put(file).then((snapshot) => { 
      return snapshot.ref.getDownloadURL();
    });
}

async function uploadImagesAndGetUris(userId, storageRef, data) {
  if (data.cover.constructor === File) {
    try {
      const resized = await resizeImage(data.cover, "cover");
      data.cover = await uploadImage(resized, userId, "cover", storageRef);
    } catch (err) {
      if (debug) console.error(err);
    }
  }

  if (data.pic1.constructor === File) {
    try {
      const resized = await resizeImage(data.pic1, "pic1");
      data.pic1 = await uploadImage(resized, userId, "pic1", storageRef);
    } catch (err) {
      if (debug) console.error(err);
    }
  }

  return data;
}

function dataURItoFile(dataURI, filename) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
  else
      byteString = unescape(dataURI.split(',')[1]);
  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  var blob = new Blob([ia], {type:mimeString});
  return new File([blob], filename, {type:mimeString});
}

async function getCoordinates(queryString, data) {
  if (typeof window !== 'undefined') {
    const provider = new OpenStreetMapProvider();
    const results = await provider.search({ query: queryString});
    if (results.length) {
      data.position = [results[0].y, results[0].x];
      return data;
    }
  }
  data.position = false;
  return data;
}

const resizeImage = (file, type) =>
  new Promise((resolve) => {
    var width = 400;
    var height = 400;
    if (type === "cover") {
        width = 1000;
        height = 800;
    }
    Resizer.imageFileResizer(
      file,
      width,
      height,
      "WEBP",
      100,
      0,
      (uri) => {
        resolve(dataURItoFile(uri));
      },
      "base64",
      200,
      200
  );
});